import endpoints from "config/endpoints";
import { useMemo } from "react";
import useAxiosRequest from "./common/useAxiosRequest";

const useRendas = () => {
  const { data, loading, error } = useAxiosRequest({
    url: endpoints.rendas(),
    method: "GET",
    autoRun: true,
  });

  const faixasRenda = useMemo(
    () =>
      data?.faixaRenda?.map(({ identificador, descricao }) => ({
        id: identificador,
        value: descricao,
      })),
    [data]
  );

  return { faixasRenda, loading, error };
};

export default useRendas;
